import { render, staticRenderFns } from "./SelflaneIcon.vue?vue&type=template&id=41362890&scoped=true&"
var script = {}
import style0 from "./SelflaneIcon.vue?vue&type=style&index=0&id=41362890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41362890",
  null
  
)

export default component.exports